/**
 * `offsetTop` relative to `container`. A group's sub-list becomes the `offsetParent` while its
 * entrance `translate` runs, so a single `offsetTop` would measure from the wrong box.
 */
export function offsetTopWithin(element: HTMLElement, container: HTMLElement) {
  let top = 0;
  let node: HTMLElement | null = element;
  while (node && node !== container) {
    top += node.offsetTop;
    node = node.offsetParent instanceof HTMLElement ? node.offsetParent : null;
  }
  return top;
}
